export class CookiesMessage {
    private readonly monthUnixTime: number = 2629743;

    private readonly cookiesMessageElement: HTMLDivElement;

    constructor() {
        this.cookiesMessageElement = document.querySelector('.cookies-message');
        const cookiesConfirmDate: string = localStorage.getItem('cookiesConfirmDate');
        if (!cookiesConfirmDate || Number(cookiesConfirmDate) + this.monthUnixTime * 2 < Date.now() / 1000.0) {
            this.cookiesMessageElement.classList.add('visible');
        }
        const confirmButton: HTMLButtonElement = document.querySelector('.cookies-message__button');
        confirmButton.addEventListener('click', (): void => this.confirmButtonClick());
    }

    private confirmButtonClick(): void {
        localStorage.setItem('cookiesConfirmDate', String(Date.now() / 1000.0));
        this.cookiesMessageElement.classList.remove('visible');
    }
}
